module.exports = __webpack_public_path__ + "img/norfolk-island.d8432627.svg";